// extracted by mini-css-extract-plugin
export default {"termsDetails":"TermsOfService_termsDetails__f8PUc","h4":"TermsOfService_h4__JacIP"};